<template>
  <span class="clip_list connectedSortable" :data-section="sectionKey">
    <div v-if="this.searchSuggestionsSetting == 'yes'">
      <div
        v-if="
          Object.keys(sectionClips).length === 0 &&
          sectionClips.constructor === Object
        "
      >
        <p class="text-center no-clip-msg">no clips have been added yet.</p>
        <p class="suggestion-text text-uppercase">
          Suggested: Clips About {{ sectionName }}
          <a
            class="view-more-link"
            :href="
              route('user.resources', {
                query: `type=clip&key=&clip_location=&clip_type[${clip_type_id}]=${clip_type_id}`,
              })
            "
            target="_blank"
          >
            View More</a
          >
        </p>
        <clip-suggestion-slider
          @calculateSelectedClips="setSelectedClips"
          :ref="`clipSuggestionSlider-${sectionKey}`"
          :section-key="sectionKey"
          :bookId="bookId"
        ></clip-suggestion-slider>
      </div>
    </div>
    <draggable
      class="dragArea"
      :options="{
        handle: '.clip-reorder-confirm',
        group: { name: 'clips', put: true, pull: true },
        ghostClass: 'ghost',
        forceFallback: true,
        fallbackTolerance: 0,
        swapThreshold: 1,
        invertSwap: false,
        invertedSwapThreshold: 0.5,
        direction: 'vertical',
        dragClass: 'sortable-drag',
      }"
      @choose="selectDrag"
      @start="startDrag"
      @end="stopDrag"
    >
      <transition-group :data-section="sectionKey" class="dragArea">
        <li
          class="clip-movable state-disabled"
          :key="0"
          :data-section="sectionKey"
        >
          <div class="static-clip"></div>
        </li>
        <li
          class="clip-movable state-disabled"
          v-for="clip in sectionClips"
          v-model="sectionClips"
          :key="clip.id"
          :id="clip.slug"
          :data-id="clip.id"
          :data-section="sectionKey"
        >
          <div class="manage-clip">
            <div class="top clear-float node-clip-metas-bar">
              <div class="clips-added-message" v-if="showMessage(clip)">
                <p>{{ trans("clip.singular") }} {{ clip.message }}</p>
              </div>
              <div class="clips-metas-section">
                <div class="sub-menu">
                  <div class="item-list">
                    <ul class="inline">
                      <li condition="1" class="reorder_icon first">
                        <a class="reorder-link">
                          REORDER
                          <i class="fa fa-arrows"></i>
                        </a>
                      </li>
                      <li condition="1" class="delete_icon last">
                        <a class="remove-clip-btn">
                          REMOVE
                          <i class="glyphicon glyphicon-trash"></i>
                        </a>
                      </li>
                      <li
                        v-if="clip.user_id == currentUser"
                        condition="1"
                        class="edit_icon"
                      >
                        <a
                          class
                          :href="
                            route('user.clip.edit', { slug: clip.slug }) +
                            bindCurrentURL()
                          "
                          target="_blank"
                        >
                          EDIT
                          <i class="fa fa-pencil"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="maincontent-clip">
              <div v-if="hasSocialContent(clip)" class="main-content-img">
                <div v-if="clip.cliptype == 'image'">
                  <img
                    class="hdot_image_img img-responsive"
                    typeof="foaf:Image"
                    v-bind:src="clip.default_clip_image"
                    width="281"
                    height="260"
                    :alt="clip.title"
                  />
                </div>
                <div
                  v-else-if="clip.cliptype == 'audio'"
                  v-html="clip.audio"
                ></div>
                <div
                  v-else-if="clip.cliptype == 'video'"
                  v-html="clip.video"
                ></div>
              </div>
              <div class="maincontent1 clear-float">
                <div class="right no-left">
                  <h4>
                    <a
                      :href="route('user.clip.show', { slug: clip.slug })"
                      target="_blank"
                      >{{ clip.title }}</a
                    >
                  </h4>
                  <div class="contributor text-capitalize">
                    Contributed by
                    <a
                      v-if="clip.user && clip.user.user_type === '0'"
                      :href="route('user.show', { slug: clip.user.slug })"
                      target="_blank"
                      class="grey-link"
                      >{{ clip.user.first_name }}</a
                    >
                    <a
                      v-else-if="clip.user"
                      :href="route('user.show', { slug: clip.user.slug })"
                      target="_blank"
                      class="grey-link"
                      >{{ clip.user.first_name + " " + clip.user.last_name }}</a
                    >
                  </div>
                  <div
                    class="body"
                    :class="hasSocialContent(clip) ? 'has-left-section' : ''"
                  >
                    <div
                      v-html="
                        $options.filters.getWords(clip.plain_content, 70, '...')
                      "
                      class="clip-body-content"
                    ></div>
                    <div class="clip-body-expand">
                      <div v-html="clip.content"></div>
                    </div>
                  </div>
                  <div class="bottom clear-float">
                    <a href class="view-more brandon_grotesque_bold">
                      VIEW MORE
                      <i class="fa fa-expand"></i>
                    </a>
                    <div class="section-detail">
                      <span class="title"
                        >{{ trans("clip.Singular") }} Type:</span
                      >
                      <!-- {{ showSectionName(clip.section_id) }} -->
                      {{ sectionName }}
                    </div>
                    <div class="source-section-detail">
                      <span class="title">Source:</span>
                      {{ clip.clipsource | trim24 }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="remove-clip-confirm hide">
                <div class="top-highlight-wrap">
                  <span class="top-highlight-icon">
                    REMOVE
                    <i class="glyphicon glyphicon-trash"></i>
                  </span>
                </div>
                <h2 class="title">Delete this {{ trans("clip.singular") }}?</h2>
                <div class="actions">
                  <a
                    class="use-ajax btn btn-blue"
                    @click.prevent="removeClip(clip.id)"
                    >YES, DELETE</a
                  >
                  <a class="btn btn-cancel">Cancel</a>
                </div>
                <div class="caution">Caution: This can't be undone</div>
              </div>
              <div class="clip-reorder-confirm hide">
                <div class="top-highlight-wrap">
                  <span class="top-highlight-icon">
                    REORDER&nbsp;
                    <i class="fa fa-arrows"></i>
                  </span>
                </div>
                <div class="clips-reorder-drag-section">
                  <h2 class="title">
                    Drag {{ trans("clip.singular") }} to reorder
                  </h2>
                  <div class="actions">
                    OR
                    <br />
                    <br />
                    <span
                      class="clip-move-btn btn btn-blue btn-square btn-lg brandon_grotesque_bold"
                      >MOVE TO A DIFFERENT SECTION</span
                    >
                    <br />
                    <br />
                    <a class="btn btn-cancel">Cancel</a>
                  </div>
                </div>
                <div class="clip-move-section hide">
                  <h2>Move {{ trans("clip.singular") }} to another section</h2>
                  <div class="move_clip_form_container">
                    <form
                      action="#"
                      method="post"
                      :id="'move-clip-frm-' + clip.id"
                    >
                      <input
                        type="hidden"
                        name="current_clip_section"
                        :value="sectionKey"
                      />
                      <input
                        type="hidden"
                        name="current_clip_position"
                        :value="clip.pivot.position"
                      />
                      <input type="hidden" name="book_id" :value="bookId" />
                      <input type="hidden" name="clip_id" :value="clip.id" />
                      <input
                        type="hidden"
                        name="section_id"
                        :value="changed_section_id"
                      />
                      <div class="section-drpdown form-group">
                        <chosen-select
                          ref="sectionChosen"
                          @input="setSection"
                          style="width: 100%"
                        >
                          <option
                            v-for="(item, index) in bookSections"
                            :key="index"
                            :value="item"
                          >
                            {{ item }}
                          </option>
                        </chosen-select>
                      </div>
                      <input
                        class="move_clip_submit_form form-submit"
                        type="submit"
                        name="move_submit"
                        :value="`Move ${trans('clip.singular')}`"
                        @click.prevent="saveDirectMoveSection(clip)"
                      />
                      <span
                        class="move_clip_form_disabled btn"
                        @click.prevent="hideMoveSection(clip.id)"
                        >Cancel</span
                      >
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </transition-group>
    </draggable>
  </span>
</template>

<script>
import draggable from "vuedraggable";
import ClipSuggestionSlider from "../components/ClipSuggestionSlider";
import { mapMutations } from "vuex";

export default {
  props: [
    "bookId",
    "currentUser",
    "sectionKey",
    "bookSections",
    "sectionName",
    "clip_type_id",
    "searchSuggestionsSetting",
  ],
  components: {
    draggable,
    ClipSuggestionSlider,
  },
  data() {
    return {
      current_clip_slug: "",
      current_clip_section: "",
      current_clip_position: "",
      changed_section_id: 0,
    };
  },
  computed: {
    clips: function () {
      let saved_list = this.$store.state.savedClipList;
      return saved_list;
    },
    sectionClips: function () {
      var vm = this;
      let list = this.$store.state.savedClipList;
      let saved_list = this.$store.getters.getCurrentSectionClips(
        vm.sectionKey
      );
      return saved_list;
    },
  },
  mounted: function () {
    var vm = this;
    $(".clip-movable:empty").remove();
  },
  filters: {
    getWords: function (value, return_words, last_word = "") {
      if (!value) return "";

      if (value.length > return_words) {
        value = value.replace(/(?:<br[^>]*>\s*){2,}/g, "<br>");
        return value.split(/\s+/).slice(0, return_words).join(" ") + last_word;
      }
      return value;
    },
    coverImage(src) {
      var src_path = src.split("/");
      src_path.pop();
      src_path.push("conversions");
      src_path.push("cover.jpg");

      var result = src_path.join("/");
      return result;
    },
    trim24: function (value) {
      if (!value) return "";
      return value.substring(0, 24);
    },
  },
  methods: {
    showMessage(clip) {
      var currentURL = window.location.href;
      var specificValue = "legacy.haggadot";
      if (currentURL.indexOf(specificValue) !== -1) {
      } else {
        if (clip.status) {
          delete clip.status;
          this.notify(
            "success",
            `The ${this.trans("clip.Singular")} is added into  ${this.trans(
              "book.singular"
            )}.`
          );
          setTimeout(function () {
            delete clip.status;
            $(".clips-added-message").remove();
          }, 3000);
          return true;
        }
        return false;
      }
    },
    showSectionName(clip) {
      var vm = this;
      var book_secitons = vm.bookSections;
      var section_id = clip.section_id;
      // var section_name = book_secitons[section_id];
      var section_name = clip.type_of_custom;
      console.log(section_name);
      if (typeof section_name === "undefined") {
        return "";
      }
      $(".clip-movable:empty").remove();
      return section_name;
    },
    removeClip(id) {
      let vm = this;
      this.$store.commit("isLoading", true);
      axios
        .post(this.route("user.book.removeClipFromBook", { id: this.bookId }), {
          clip_id: id,
        })
        .then(({ data }) => {
          if (data == "legacy_site") {
            vm.$parent.$parent.setData(vm.bookId);
            this.notify(
              "success",
              "Validation error"
            );
          } else {
            vm.$parent.$parent.setData(vm.bookId);
            this.notify(
              "success",
              `The ${this.trans("clip.singular")} is removed from ${this.trans(
                "book.singular"
              )}.`
            );
          }
        });
    },
    hasSocialContent(clip) {
      if (clip.cliptype !== "text") {
        return true;
      }
      return false;
    },
    setSection(section) {
      let vm = this;
      let section_id = "";
      $.each(vm.bookSections, function (index, val) {
        if (val === section) {
          section_id = index;
        }
      });
      vm.changed_section_id = section_id;
    },
    selectDrag: function (evt) {
      //Set the current clip slug
      this.$emit("updateDrag", { current_clip_slug: evt.item.id });
    },
    startDrag: function (evt) {
      //Set the current clip slug
      // console.log("test");
      this.current_clip_slug = evt.item.id;
    },
    // Element dragging ended
    stopDrag: function (/**Event*/ evt) {
      var vm = this;
      this.$store.commit("isLoading", true);
      this.$store.commit("isDraggable", { is_draggable: true });

      vm.current_clip_section = evt.to.attributes["data-section"].value;
      vm.current_clip_position = evt.newIndex + 1; // NewIndex value start from 0 so always need to add 1 for get exact position
      // console.log(evt.to.attributes['data-section'].value);

      var list = {},
        clips = {},
        keys;
      var current_clip = $("#" + evt.item.id);
      var current_clip_section = evt.item.attributes["data-section"].value;

      current_clip.data("section", current_clip_section);

      clips = $(
        ".insert-clip-detail .connectedSortable li.clip-movable .manage-clip"
      );
      $.each(clips, function (index, clip) {
        var clip_slug = $(clip).parents("li").attr("id");
        var section_id = $(clip).parents("li").data("section");
        var list_key = list.section_id;
        // console.log(list);
        if (!(section_id in list)) {
          list[section_id] = {};
          keys = 0;
          list[section_id][keys] = $(clip).parents("li").attr("id");
        } else {
          var last_key = Object.keys(list[section_id]).length;
          list[section_id][last_key] = $(clip).parents("li").attr("id");
        }
      });

      axios
        .post(this.route("user.book.updateClipPostion", { id: this.bookId }), {
          clip_list: list,
          current_clip_slug: vm.current_clip_slug,
          current_clip_section: vm.current_clip_section,
          current_clip_position: vm.current_clip_position,
        })
        .then(({ data }) => {
          if (data == "legacy_site") {
            this.notify(
              "success",
              "Validation error"
            );
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          } else {
            vm.$parent.$parent.setData(vm.bookId);
            this.$nextTick(function () {
              $("#" + evt.item.id)
                .find(".clip-reorder-confirm")
                .addClass("hide");
              vm.scrollToSection(vm.current_clip_section);
              this.notify(
                "success",
                `The ${this.trans("clip.singular")} is moved successfully.`
              );
            });
          }
        });
      setTimeout(function () {
        vm.$store.commit("isDraggable", { is_draggable: false });
      }, 1000);
    },
    hideMoveSection(clip_id) {
      var mainElement = jQuery("#move-clip-frm-" + clip_id).parents(
        ".clip-reorder-confirm"
      );
      mainElement.find(".clip-move-section").addClass("hide");
      mainElement.find(".clips-reorder-drag-section").removeClass("hide");
    },
    saveDirectMoveSection(clip) {
      var vm = this;

      axios
        .post(
          this.route("user.book.updateSingleClipPosition", { id: vm.bookId }),
          {
            clip_id: clip.id,
            current_clip_section: clip.pivot.section_id,
            current_clip_position: clip.pivot.position,
            new_section_id: vm.changed_section_id,
          }
        )
        .then(({ data }) => {
          if (data == "legacy_site") {
            this.notify(
              "success",
              "Validation error"
            );
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          } else {
            this.$nextTick(function () {
              vm.refreshData(clip);
              this.scrollToSection(vm.changed_section_id);
              this.notify(
                "success",
                `The ${this.trans("clip.singular")} is moved successfully.`
              );
            });
          }
        });
    },
    getSectionName(sectionName) {
      if (!sectionName) {
        sectionName = this.changed_section_id;
      }
      if (sectionName in this.bookSections) {
        var sectionSlug = this.bookSections[sectionName]
          .toString()
          .toLowerCase()
          .trim()
          .replace(/\s+/g, "-") // Replace spaces with -
          .replace(/&/g, "-and-") // Replace & with 'and'
          .replace(/[^\w\-]+/g, "") // Remove all non-word chars
          .replace(/\-\-+/g, "");
        return "#" + sectionSlug;
      }
      return "";
    },
    scrollToSection(sectionName) {
      var hashed = this.getSectionName(sectionName);
      if (hashed) {
        var currentUrl = window.location.pathname + hashed;
        window.location = currentUrl;
      }
    },
    refreshData(clip) {
      var vm = this;
      vm.$parent.$parent.setData(vm.bookId);
      this.$nextTick(function () {
        $("#" + clip.slug)
          .find(".clip-reorder-confirm")
          .addClass("hide");
      });
    },
    bindCurrentURL() {
      return "?_url=" + encodeURIComponent(window.location);
    },
    setSelectedClips(selectedClips) {
      console.log(`setSelectedClips on cliplist.vue`, selectedClips);
      this.selectedClips = selectedClips;
      this.selectedClipsCount = selectedClips.length;
    },
  },
};

jQuery(document).on("submit", ".clip-reorder-confirm form", function (event) {
  event.preventDefault();

  var inputs = jQuery(this).serializeArray();

  // console.log(inputs);
});

function updateSectionOfIndividualClip(data) {
  var book_id = data["book_id"];
  var clip_id = data["clip_id"];
  var section_id = data["section_id"];
  var current_clip_section = data["current_clip_section"];
  var current_clip_position = data["current_clip_position"];
}
</script>
<style>
.dragArea {
  min-height: 1px;
}
.static-clip {
  min-height: 10px;
}
.ghost {
  opacity: 0;
  background: #c8ebfb;
}
.move_clip_form_container {
  margin: 50px 0px;
}
.section-drpdown {
  width: 255px;
  display: inline-block;
}
.clip-move-section .chosen-container {
  width: 100% !important;
}
.no-clip-msg {
  padding: 15px;
  font-family: "brandon-grotesque";
  font-size: 20px;
  font-weight: 500;
}
</style>